// s119 (D532): where a tapped push opens the app. Only a path inside the app ('/...', never '//host' or a URL);
// anything else opens the notices list. Pure (scripts/check-native-push.mjs imports it).
export function safePushPath(url) {
  if (typeof url !== 'string') return '/notifications'
  const u = url.trim()
  if (!u.startsWith('/') || u.startsWith('//') || u.includes('\\') || u.length > 300) return '/notifications'
  return u === '/' ? '/notifications' : u
}
